<template>
    <div class="main--content-header content-header">
        <div class="content-header--navbar" :class="!hasDefaultSlotData ? 'full-mobile' : ''" v-if="Object.keys(links).length > 0">
            <ul class="content-header--navbar-list">
                <li
                    class="content-header--navbar-list-item"
                    v-if="!link.hide"
                    v-bind:class="link.active ? 'active' : ''"
                    v-for="(link,index) in links"
                    :key="index"
                >
                    <a
                        class="content-header--navbar-list-item-link"
                        v-on:click="action(link)"
                        :href="link.link ? link.link : 'javascript:void(0);'"
                    >{{link.label}}</a>
                </li>
            </ul>
        </div>
        <div class="content-header--left" v-else>
            <slot name="left"></slot>
        </div>
        <div class="content-header--right">
            <slot></slot>
        </div>
    </div>
</template>

<script>
	export default {
        name: "ContentHeader",

        props: {
            'links': {
                type: [Array, Object],
                default: () => { return {} }
            }
        },

        methods: {
            action(item){
                if (!item.on_click) return;
                item.on_click(...item.on_click_params);
            }
        },

        computed: {
            hasDefaultSlotData() {
                return this.$slots.default !== undefined;
            }
        }
	}
</script>
